module.exports = __webpack_public_path__ + "img/Viber.0c5a4e39.svg";